var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticClass:"grey lighten-3 pt-12",class:[
    !_vm.semMenuLateral && _vm.$vuetify.breakpoint.mdAndUp ? 'menu-lateral-desktop' : '',
    _vm.rodape && _vm.$vuetify.breakpoint.mdAndUp ? 'interna-desktop' : '',
    _vm.rodape && _vm.$vuetify.breakpoint.smAndDown ? 'interna-mobile' : '' ]},[_c('v-container',{staticClass:"mx-auto pt-0",style:(("max-width:" + _vm.maxwidthContainer + ";"))},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }